import { useNavigate } from "react-router-dom"

const ButtonRating = ({value, project_id, bu, prev_calibrator, rating, all=false, projectPhaseOrder}) => {
    const navigate = useNavigate()
    const query = projectPhaseOrder ? `?projectPhaseOrder=${encodeURIComponent(projectPhaseOrder)}` : ""
    return(
        <button className="btn" style={{fontSize: 12}}
            onClick={() => {
                if (all) {
                    if (bu) {
                        navigate(`/projects-summary-rating/${project_id}/${bu}/${rating}/1${query}`)
                    } else{
                        navigate(`/projects-summary-rating/${project_id}/${rating}/1${query}`)
                    }
                } else {
                    navigate(`/projects-summary-rating/${project_id}/${bu}/${prev_calibrator}/${rating}/1${query}`)
                }
            }}
        >
            <i style={{margin:0}}>
                {value}
            </i>
        </button>
    )
}

export default ButtonRating